import React from 'react';
import { Icon } from './Icon.js';
export const IconHouse6 = ({ ...props }) => {
    return (React.createElement(Icon, { size: "24px", ...props },
        React.createElement("path", { d: "M12 2L2 9.5V10.5L4 11V21H9V14H15V21H20V11L22 10.5V9.5L12 2Z", stroke: "currentColor", strokeWidth: "2", fill: "none" })));
};
//# sourceMappingURL=IconHouse6.js.map